<template>
  <div class="shopInfoManage">
    <div class="title">
      <p>店铺管理</p>
    </div>
    <div class="main"
         v-loading="load">
      <el-card>
        <div class="subtitle">
          <h4>
            店铺信息
            <p>
              当前<span>{{ list.length }}</span>家店铺
            </p>
          </h4>
          <el-button type="primary"
                     size="small"
                     @click="$router.push('/home/ShopManage')">新店申请</el-button>
        </div>
      </el-card>
      <el-card v-for="(item, index) in list"
               :key="index">
        <div class="shop-info">
          <div class="shop-title">
            <div class="tl">
              <h3>{{ item.name }}</h3>
              <!-- <p>店铺评分</p> -->
              <!-- <el-rate v-model="rate"></el-rate> -->
            </div>
            <div class="tr">
             <!--  <el-button v-show="item.deposit == 1"
                         size="small"
                         plain
                         type="info"
                         @click="categoryView(item.id, item.deposit)">查看类目押金</el-button>
              <el-button v-show="item.deposit == 0"
                         size="small"
                         plain
                         type="danger"
                         @click="categoryView(item.id, item.deposit)">类目押金不足</el-button> -->
           <!--    <el-button size="small"
                         type="primary"
                         plain
                         @click="shopInfoDia(item.shop_id,'fouth')">店铺资金</el-button> -->
              <el-button size="small"
                         type="primary"
                         plain
                         @click="shopInfoDia(item.shop_id)">店铺信息</el-button>
            </div> 
          </div>
          <p class="date">开店时间：{{ item.audit_time }}</p>
          <div class="list">
            <div class="item">
              <span class="round"></span>
              <p v-if="item.goods_count[0]">{{ item.goods_count[0].total }}</p>
              <p>商品总数</p>
            </div>
            <div class="item">
              <span class="round"></span>
              <p v-if="item.order[0]">{{ item.order[0].order_count }}</p>
              <p>订单总数</p>
            </div>
            <div class="item">
              <span class="round"></span>
              <p  v-if="item.order[0]">{{ item.order[0].order_price }}</p>
              <p>订单交易金额</p>
            </div>
            <div class="item">
              <span class="round"></span>
              <p>{{ item.goods_uv }}</p>
              <p>店铺总UV</p>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <ShopInfo @showWeChat="showWeChat"
              @showAlipay="showAlipay"
              ref="refShopInfo"
              @viewHistory="viewHistory"
              @payShow="payShowThaw"
              @addCategory="addCategory"></ShopInfo>
    <CategoryManage ref="refCategoryManage"
                    @showPay="showPay"></CategoryManage>
    <CategoryHistoryDia ref="refCategoryHistoryDia"
                        @payShow="payShow"></CategoryHistoryDia>
    <CreateCategory ref="refCreateCategory"
                    @init="initInfo"></CreateCategory>
    <Pay ref="refPay"
         :shop_id="shop_id"></Pay>
    <CreateAlipayDia ref="refCreateAlipayDia"
                     :ali_status="ali_status"></CreateAlipayDia>
    <CreateWeChatDia ref="refCreateWeChatDia"
                     :wx_status="wx_status"></CreateWeChatDia>
    <CreateWeChatDetails ref="refCreateWeChatDetails"></CreateWeChatDetails>
    <CreateAlipayDetails ref="refCreateAlipayDetails"></CreateAlipayDetails>
  </div>
</template>

<script>
import CreateAlipayDetails from '@/components/Modules/Account/createAlipayChatDetails.vue'
import ShopInfo from "@/components/Modules/ShopManage/ShopInfo.vue";
import CategoryManage from "@/components/Modules/ShopManage/CategoryManage.vue";
import CategoryHistoryDia from "@/components/Modules/ShopManage/CategoryHistoryDia.vue";
import CreateWeChatDetails from '@/components/Modules/Account/createWeChatDetails.vue'
import CreateCategory from "@/components/Modules/ShopManage/CreateCategory.vue";
import Pay from "@/components/Modules/ShopManage/Pay.vue";
import CreateAlipayDia from "@/components/Modules/Account/createAlipayDia.vue";
import CreateWeChatDia from "@/components/Modules/Account/createWeChatDia.vue";

import { mapGetters, mapActions } from "vuex";
export default {
  data () {
    return {
      load: false,
      list: [],
      shop_id: "",
      total_amount: 0,
      wx_status: '',
      ali_status: '',

    };
  },
  components: {
    ShopInfo,
    CategoryManage,
    CategoryHistoryDia,
    CreateWeChatDetails,
    CreateCategory,
    Pay,
    CreateAlipayDia,
    CreateWeChatDia,
    CreateAlipayDetails
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  created () {
    this.getShopList();
    this.getList();
  },
  methods: {
    ...mapActions({
      shoptypelist: "detect/shoptypelist",
      storeapplyGoods: "detect/storeapplyGoods",
      openAccountCheckWx: "detect/openAccountCheckWx",
      apliySubmitquery: "detect/apliySubmitquery",
    }),
    showWeChat (wx_status) {
      this.$refs.refShopInfo.dialogVisible = false;
      this.wx_status = wx_status
      if (this.wx_status == 0 || this.wx_status == 1 || this.wx_status == 3) {
        this.$refs.refCreateWeChatDetails.dialogVisible = true;
        this.getopenAccountCheckWx()
      } else {
        this.$refs.refCreateWeChatDia.dialogVisible = true;
      }
    },
    getopenAccountCheckWx () {
      this.openAccountCheckWx({ token: this.getToken }).then(({ data }) => {
        if (data.code == 1) {
          let obj = {
            applyment_state: data.data.applyment_state
          }
          if (data.data.legal_validation_url) {
            obj.legal_validation_url = data.data.legal_validation_url
          }
          if (data.data.sign_url) {
            obj.sign_url = data.data.sign_url
          }
          this.$refs.refCreateWeChatDetails.applyinfor = obj;
        }
      })
    },
    getapliySubmitquery () {
      this.apliySubmitquery({ token: this.getToken }).then(({ data }) => {
        if (data.code == 1) {
           this.$refs.refCreateAlipayDetails.applyinforA =data.data[0]
        }
      })
    },
    showAlipay (ali_status) {
      this.$refs.refShopInfo.dialogVisible = false;
      this.ali_status = ali_status
      if (this.ali_status == 0 || this.ali_status == 1 || this.ali_status == 3) {
        this.$refs.refCreateAlipayDetails.dialogVisible = true;
          this.getapliySubmitquery()
      }else {
        this.$refs.refCreateAlipayDia.dialogVisible = true;
      }
    },
    payShowThaw (row) {
      this.$refs.refPay.dialogVisible = true;
      this.$refs.refPay.rowInfo = row;
      this.$refs.refPay.type = "thaw";
      this.$refs.refPay.rowInfo = JSON.parse(JSON.stringify(row));
      this.$refs.refPay.onSubmit();
    },
    payShow (row) {
      this.$refs.refPay.dialogVisible = true;
      this.$refs.refPay.type = "pay";
      this.$refs.refPay.rowInfo = JSON.parse(JSON.stringify(row));
      console.log(row, 'row-----')
      this.$refs.refPay.onSubmit();
    },
    showPay (ids, all_price) {
      this.$refs.refPay.ids = ids;
      this.$refs.refPay.type = "class";
      this.$refs.refPay.all_price = all_price;
      this.$refs.refPay.dialogVisible = true;
      this.$refs.refPay.onSubmit();
    },
    initInfo () {
      this.$refs.refShopInfo.getCategoryList();
    },
    addCategory () {
      this.$refs.refCreateCategory.dialogVisible = true;
      this.$refs.refCreateCategory.shop_id = this.shop_id;
    },
    viewHistory (id) {
      this.$refs.refCategoryHistoryDia.dialogVisible = true;
      this.$refs.refCategoryHistoryDia.getCategoryList(id);
    },
    // 已申请店铺列表
    getList () {
      this.load = true;
      this.storeapplyGoods({ token: this.getToken }).then(({ data }) => {
        this.load = false;
       console.log(data);
        if (data.code == 1) {
          this.list = data.data.shop;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 店铺类型列表 ///merchant /store/apply/goods/numbet
    getShopList () {
      this.shoptypelist({ token: this.getToken }).then(({ data }) => {
        if (data.code == 1) {
          localStorage.setItem("shop", JSON.stringify(data.data));
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    shopInfoDia (id,source = 'first') {
      this.shop_id = id;
        this.$refs.refShopInfo.id = id;
      this.$refs.refShopInfo.dialogVisible = true;
      this.$refs.refShopInfo.activeName = source;
      this.$refs.refShopInfo.handleClick();
    },
    categoryView (id) {
      this.shop_id = id;
      this.$refs.refCategoryManage.dialogVisible = true;
      this.$refs.refCategoryManage.shop_id = id;
      this.$refs.refCategoryManage.getList(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.shopInfoManage {
  .title {
    width: 100%;
    background: #fff;
    padding: 15px 32px;
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    p {
      font-size: 20px;
      color: #000000;
      margin-left: 0;
    }
  }
  .main {
    min-width: 1200px;
    padding: 20px;
    .el-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .shop-info {
        height: 308px;
        .list {
          display: flex;
          justify-content: space-around;
          margin: 40px 0;
          .item {
            text-align: center;
            width: 20%;
            &:nth-child(1) {
              .round {
                border: 12px solid #fb7369;
              }
            }
            &:nth-child(2) {
              .round {
                border: 12px solid #48eadc;
              }
            }
            &:nth-child(3) {
              .round {
                border: 12px solid #a46ded;
              }
            }
            &:nth-child(4) {
              .round {
                border: 12px solid #ffc066;
              }
            }
            .round {
              margin: 0 auto 14px;
              display: block;
              border-radius: 50%;
              width: 90px;
              height: 90px;
            }
            p {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #333333;
              line-height: 24px;
            }
          }
        }
        .date {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-top: 8px;
          line-height: 20px;
        }
        .shop-title {
          .tl {
            display: flex;
            align-items: center;
            h3 {
              margin-right: 40px;
              font-size: 20px;
            }
            p {
              margin-right: 8px;
            }
          }
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
    }
    .subtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h4 {
        font-size: 18px;
        padding-left: 20px;
        line-height: 18px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 2px;
          background: #2448ff;
        }
        p {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-left: 40px;
          span {
            color: #2448ff;
          }
        }
      }
    }
  }
}
</style>